const isPhoneNumberValid = (phoneNumber: string): boolean  => {
        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        return !!phoneNumber && phoneRegex.test(phoneNumber);
    }

export default isPhoneNumberValid